module.exports = __webpack_public_path__ + "static/media/icons.022583c4.svg";